import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { User } from '../models/user.model';
const TOKEN_KEY = 'x-access-token';
const USER_KEY = 'user';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  saved=false
  constructor(private router: Router,private userservice: UserService,) { }
  signOut(): void {
    const currentUser = this.getUser();
    
    // Check if user is available before proceeding
    if (currentUser) {
      console.log('her token storage')
      this.userservice.getUserById(currentUser.userId).then(
        (user: User) => {
          console.log('get here22233')
          window.localStorage.clear();
          // Update user connection status
          user.connected = false;
          this.router.navigate(['home']).then(
            () => {
              window.location.reload()        
            }
          )
          // Disconnect user from the system
         /* this.userservice.disconnectUser(user._id, user).then(() => {
            console.log('get here')
            // Clear local storage after successful disconnection
            window.localStorage.clear();
            // Navigate to login page after clearing local storage
            this.router.navigate(['auth/login']).then(() => {
              window.location.reload()
            });          
            this.saved = true;
          }).catch((error) => {
            console.error('Error disconnecting user:', error);
          });*/
        }
      ).catch((error) => {
        console.error('Error fetching user:', error);
      });
    }
    else{
      console.log('here mouch mawjoud token storage')
      window.localStorage.clear();
    }
  }
  
  public saveToken(token: string): void {
    
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY,token);
  }
  public getToken(): string | null {
    
    return window.localStorage.getItem(TOKEN_KEY);
  }
  public saveUser(user: any): void {
    
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
  public getUser(): any {
    
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }
}